module.exports = __webpack_public_path__ + "style/ckm-style/images/blbglogo.png?5f07783ba28ec75317e5889b273d6afa";